import { useEffect, useRef } from "react";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { updateTokens } from "../../auth/authSlice";
import { refreshTokens, isTokenExpired } from "../../api/auth.api";

const TokenExpiration: React.FC = () => {
  const dispatch = useAppDispatch();
  const refreshingRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");

        if (!accessToken || !refreshToken) {
          return;
        }

        if (isTokenExpired(accessToken, 60) && !refreshingRef.current) {
          refreshingRef.current = true;

          try {
            const { accessToken: newAccessToken, refreshToken: newRefreshToken, decodedToken } = 
              await refreshTokens(refreshToken);
            
            dispatch(
              updateTokens({
                accessToken: newAccessToken,
                refreshToken: newRefreshToken,
                user: decodedToken,
              })
            );
          } catch {
            window.location.href = "https://login.intranetsonrie.site/";
          } finally {
            refreshingRef.current = false;
          }
        }
      } catch {
        // Error silencioso
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return null;
};

export default TokenExpiration;
